import { render } from "./DuoToneTeamingLogo.vue?vue&type=template&id=82302f50&scoped=true"
import script from "./DuoToneTeamingLogo.vue?vue&type=script&lang=js"
export * from "./DuoToneTeamingLogo.vue?vue&type=script&lang=js"

import "./DuoToneTeamingLogo.vue?vue&type=style&index=0&id=82302f50&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-82302f50"

export default script